import React, { Component } from "react";
import { connect } from "react-redux";

// Actions
import { modalProcessingFile } from "../../actions/modals";
// Hocs
import Modal from "../../hocs/Modal";
// Styles
import { Row } from "../../styles/align";
import { StyleProcessingFile } from "./style";

class ProcessingFile extends Component {
    render() {
        const usuario = localStorage.getItem("usuario");

        return (
            <StyleProcessingFile>
                <Row>
                    <h2>Atenção!</h2>
                    {usuario ? (
                        <React.Fragment>
                            <p>
                                Estamos processando o seu arquivo, isso pode levar <strong>até 5 minutos.</strong> Dependendo do tamanho do seu arquivo e da sua conexão.
                            </p>
                            <p>
                                Por favor, não atualize ou feche essa página.
                            </p>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <p>
                                Para realizar a ação de processamento de arquivos você precisa ter uma <strong>conta cadastrada</strong> na Fábrica do Livro.
                            </p>
                            <p>
                                Feche este aviso e faça seu cadastro/login.
                            </p>
                        </React.Fragment>
                    )}
                </Row>
            </StyleProcessingFile>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        text: state.modals.modalProcessingFile.text
    };
};

ProcessingFile = connect(mapStateToProps, { modalProcessingFile })(ProcessingFile);
ProcessingFile = Modal(ProcessingFile);

export default ProcessingFile;